<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-11-13 16:33:25
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Approval\ApprovalProcess\components\approvalTools.vue
 * @最后编辑: Please set LastEditors
 * @最后修改时间: 2022-05-18 11:05:24
-->
<template>
  <div>
    <v-menu
      offset-y
      color="white"
      rounded-lg
      :close-on-content-click="false"
      nudge-left="300"
      nudge-top="-6"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          height="40"
          color="primary"
          class="text-capitalize mr-4"
          rounded
        >
          {{ $t("label_essweb_approvalApplication_form_ApprovalBtnLabel") }}

          <v-icon class="material-icons">arrow_drop_down</v-icon>
        </v-btn>
      </template>
      <v-card class="pa-0">
        <v-card-text class="px-8">
          <normalInputTextFiled
            v-model="message"
            text-area
            :disabled="!matched"
            maxlength="500"
            :label="$t('label_essweb_approvalApplication_form_messageLabel')"
          />
          <v-sheet
            class="d-flex flex-row justify-space-around mt-2 flex-grow-1"
          >
            <v-sheet
              class="d-flex flex-column align-center mx-3 flex-grow-1"
              width="55"
              v-if="!(!matched || !canRevoke)"
            >
              <v-btn
                icon
                @click="toReject"
                :disabled="!matched || !canRevoke"
                rounded
                :class="
                  matched && canRevoke
                    ? 'white--text'
                    : 'grey lighten-1 white--text '
                "
                width="48"
                height="48"
                :style="{
                  backgroundColor: matched && canRevoke ? '#ff5252' : '',
                }"
              >
                <span class="material-icons white--text"> close </span>
              </v-btn>
              <span
                class="text-capitalize"
                :class="
                  matched && canRevoke ? '' : 'text--secondary text--lighten-1'
                "
                >{{
                  $t("label_essweb_approvalApplication_form_rejectLabbel")
                }}</span
              >
            </v-sheet>
            <v-sheet
              class="d-flex flex-column align-center mx-3 flex-grow-1"
              width="55"
              v-if="!(!matched || !canRollback)"
            >
              <v-btn
                icon
                @click="backApproval = true"
                rounded
                :disabled="!matched || !canRollback"
                :class="
                  matched && canRollback
                    ? 'white--text black'
                    : 'grey lighten-1'
                "
                width="48"
                color="white"
                height="48"
              >
                <svg-icon
                  size="24"
                  fill="white"
                  iconClass="arrow_left_bottom"
                />
              </v-btn>
              <span
                class="text-capitalize"
                :class="
                  matched && canRollback
                    ? ''
                    : 'text--secondary text--lighten-1'
                "
                >{{
                  $t("label_essweb_approvalApplication_form_backLabel")
                }}</span
              >
            </v-sheet>
            <v-sheet
              class="d-flex flex-column align-center mx-3 flex-grow-1"
              width="55"
              v-if="!(!matched || !canForward)"
            >
              <v-btn
                icon
                @click="forwardApproval = true"
                rounded
                :disabled="!matched || !canForward"
                width="48"
                height="48"
                :class="
                  matched && canForward
                    ? 'white--text black'
                    : 'grey lighten-1 white--text'
                "
              >
                <svg-icon size="24" fill="white" iconClass="arrow_right_top" />
              </v-btn>
              <span
                class="text-capitalize"
                :class="
                  matched && canForward ? '' : 'text--secondary text--lighten-1'
                "
                >{{
                  $t("label_essweb_approvalApplication_form_forwardLabbel")
                }}</span
              >
            </v-sheet>
            <v-sheet
              class="d-flex flex-column align-center mx-3 flex-grow-1"
              width="55"
            >
              <v-btn
                rounded
                @click="
                  final_node || admin ? approveHandle([]) : (showSender = true)
                "
                :loading="isLoading"
                :disabled="!matched || isLoading"
                width="48"
                height="48"
                :class="matched ? 'white--text' : 'grey lighten-1 white--text'"
                :style="{
                  backgroundColor: matched ? '#18a874' : '',
                }"
                icon
              >
                <span class="material-icons white--text"> send </span>
              </v-btn>
              <span
                class="text-capitalize"
                :class="matched ? '' : 'text--secondary text--lighten-1'"
                >{{
                  $t("label_essweb_approvalApplication_form_approveLabel")
                }}</span
              >
            </v-sheet>
          </v-sheet>
        </v-card-text>
      </v-card>
    </v-menu>
    <!-- tools -->
    <forwardTo
      :show="forwardApproval"
      @close="forwardApproval = false"
      :curUuid="curUuid"
      :staff_uuid="staff_uuid"
      @forward="toForward"
    />
    <backTo
      :show="backApproval"
      @close="backApproval = false"
      :curUuid="curUuid"
      @back="toBack"
    />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import backTo from "@/Page/Ess/Approval/Approval/components/backTo";
import forwardTo from "@/Page/Ess/Approval/Approval/components/forwardTo";
export default {
  name: "approvalTools",
  components: { forwardTo, backTo },
  props: {
    curUuid: { default: null, type: [String, Number] },
    staff_uuid: { default: null, type: [String, Number] },
    matched: { default: false, type: [Boolean, Number] }, //否可以被当前登录用户审批
    canForward: { default: false, type: [Boolean, Number] }, //是否允许转发
    canRollback: { default: false, type: [Boolean, Number] }, //是否允许驳回
    canRevoke: { default: false, type: [Boolean, Number] }, //是否允许终止
    canApprove: { default: true, type: [Boolean, Number] }, //是否允许审批
    canSkip: { default: false, type: [Boolean, Number] }, //是否允许跳过审批
    transUuid: { default: null, type: [String, Number] },
    data_type: { default: "", type: [String, Number] },
    flow: { default: null, type: [String, Number] },
    flag: { default: null, type: [String, Number] },
    final_node: { default: true, type: [Boolean, Number] }, //是否允许审批
    isNew: { default: false, type: [Boolean, Number] }, //2021-05-06  BJ加参数
    admin: { default: true, type: [Boolean, Number] }, //管理员审批
  },
  computed: {
    ...mapGetters(["AppInfo", "isLoading"]),
    curAppInfo() {
      return this.AppInfo ? JSON.parse(this.AppInfo) : null;
    },
  },
  data() {
    return {
      message: "",
      showSender: false,
      backApproval: false,
      forwardApproval: false,
    };
  },
  methods: {
    toReject: function () {
      const that = this;
      this.$confirmWarn(
        this.$t("message_essweb_approvalApplication_form_dialog_rejectTitle"),
        this.$t("message_essweb_approvalApplication_form_dialog_rejectLabel")
      ).then((res) => {
        if (res) that.$emit("reject", that.message);
      });
    },
    toForward: function (sender, node) {
      this.forwardApproval = false;
      this.$emit("forward", sender, node, this.message);
    },

    toBack: function (sender) {
      this.backApproval = false;
      this.$emit("back", sender, this.message);
    },
    approveHandle: function (sender, skip = false) {
      const that = this;
      if (this.final_node || this.admin) {
        that.$emit("approval", that.message, []);
      } else if (skip) {
        that.$emit("approval", that.message, sender ? sender : []);
      } else {
        that.$emit("approval", that.message, sender);
      }
    },
  },
};
</script>